import React, { useState } from "react";
import { useEffect } from "react";
import {
  useNavigate,
  UNSAFE_NavigationContext as NavigationContext,
} from "react-router-dom";

const useBlocker = (blocker: (tx: any) => void, when = true) => {
  const { navigator } = React.useContext(NavigationContext) as any;

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args: any) => {
      blocker({
        action: "PUSH",
        location: args[0],
        retry() {
          push(...args);
        },
      });
    };

    navigator.replace = (...args: any) => {
      blocker({
        action: "REPLACE",
        location: args[0],
        retry() {
          replace(...args);
        },
      });
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [blocker, navigator, when]);
};

export const useUnsavedChangesWarning = (hasUnsavedChanges: boolean) => {
  const [accept, setAccept] = useState(false)
  const navigate = useNavigate();
  const confirm = (accept?:any) => {
    if(accept) return true
    return window.confirm(
      "You have unsaved changes, do you really want to leave?"
    );
  };
  useBlocker((tx) => {
    if (
      confirm(accept)
    ) {
      tx.retry();
    }
  }, hasUnsavedChanges);

  useEffect(() => {
    if(accept)  navigate('/menu');

    const handlePopState = () => {
      if (hasUnsavedChanges) {
        !accept && window.history.pushState(null, "", window.location.pathname);
        if(confirm(accept)){
          setAccept(true)
        }
      }
    };

    if (hasUnsavedChanges)
      window.history.pushState(null, "", window.location.pathname);

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [hasUnsavedChanges, navigate, accept]);
};
